import { SettingsSection } from '$common/settings-section'
import { LabeledSwitch } from '$common/labeled-switch'
import { t } from '$i18n'
import { setNotifAudioMuted, useNotifAudio } from '$logic/notif-audio'

export function SettingsNotifs() {
  const { muted } = useNotifAudio()

  const toggleNotif = () => {
    setNotifAudioMuted(!muted)
    analite('PROFILE_SETTING_MUTE_NOTIF', { active: !muted })
  }

  return (
    <SettingsSection headerText={t('settings.sections.notification.title')}>
      <LabeledSwitch
        label={t('settings.sections.notification.mute')}
        checked={muted}
        onChange={toggleNotif}
      />
    </SettingsSection>
  )
}
